module.exports = __webpack_public_path__ + "static/media/tr.9b9a679b.png";